module.exports = __webpack_public_path__ + "img/psl-logo-colour.9b98e799.png";